import { FC, useState } from 'react';
import './ArchivedProjectError.scss';
import Env from "../../../utils/env";
import { Button, ButtonVariant } from "@patternfly/react-core";
import { patchProjectDetails } from "../../../api/pyxis";
import { useMutation } from "@tanstack/react-query";
import { ErrorPopup, SuccessPopup, useAlertContext } from "../AlertComponent/AlertContext";
import { useControllerContext } from "@rhc-shared-components/control-wrapper";
import { useParams } from "react-router";
import { CWRouteParams } from "../../../constants/router";
import { useProjectDetails } from "../../../queries/getProjectDetails";

const ArchivedProjectError: FC = () => {
    const { productId, id: projectId } = useParams<CWRouteParams>();
    const { data: projectDetails } = useProjectDetails(projectId);
    const patchMutation = useMutation({
      mutationFn: ({ id, projectData }: { id: string; projectData: any }) =>
        patchProjectDetails(id, projectData)
    });
    const [isFetching, setIsFetching] = useState(false);
    const { setAlertState } = useAlertContext();
    const { isReadOnly } = useControllerContext();

    const viewAllProjectListHandler = () => {
        setIsFetching(true);
        window.open(`${Env.productListingUrl}/projects`, "_self");
    };
    const viewProduct = () => {
        window.open(`${Env.productListingUrl}/products/${productId}/overview`, "_self");
    };
    const restoreProjectHandler = async () => {
        const requestData = {
            _id: projectId,
            project_status: "active"
        };
        try {
            setIsFetching(true);
            await patchMutation.mutateAsync({ id: projectId, projectData: requestData });
            SuccessPopup(setAlertState, `${projectDetails?.name} restored successfully`);
            window.open(`${Env.ConnectPortalUrls[Env.getEnvName()]}` + window.location.pathname.slice(1), "_self");
        } catch (error) {
            setIsFetching(false);
            ErrorPopup(setAlertState, error.message);
        }
    };

    return (
        <div className="archived-project-error-container">
            <div className="archived-project-error">
                <div className="archived-project-error--hero-gradient">
                    <div className="archived-project-error-masthead">
                        <div className="archived-project-error-masthead--content">
                            <h1 className="archived-project-error-masthead--content--header">
                                Component Archived
                            </h1>
                            <p className="archived-project-error-masthead--content--para">{projectDetails.name} is currently archived and cannot be accessed.</p>
                            <p className="archived-project-error-masthead--content--para"> The good news is it can be restored.</p>
                        </div>
                    </div>
                </div>
                <div className="archived-project-error--relative-position--cards archived-project-error--main">
                    <div className="archived-project-error--main--link-list">
                        <Button
                            variant={ButtonVariant.secondary}
                            isDisabled={isFetching || isReadOnly}
                            onClick={restoreProjectHandler}>Restore Component</Button>
                        {productId !== 'view' && (
                        <Button
                            variant={ButtonVariant.secondary}
                            isDisabled={isFetching || isReadOnly}
                            onClick={viewProduct}>Return to product</Button>
                        )}
                        <Button
                            variant={ButtonVariant.link}
                            isDisabled={isFetching}
                            onClick={viewAllProjectListHandler}>View all components</Button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ArchivedProjectError;
